import Box from '@mui/joy/Box'
import DialogTitle from '@mui/joy/DialogTitle'
import Divider from '@mui/joy/Divider'
import { default as JoyDrawer } from '@mui/joy/Drawer'
import ModalClose from '@mui/joy/ModalClose'
import Sheet from '@mui/joy/Sheet'
import { DrawerProvider, useDrawer } from 'components/Drawer/DrawerProvider'
import { ReactNode } from 'react'

type DrawerProps = {
  title: string
  open?: boolean
  onClose: () => void
  children: ReactNode
}

const DrawerContent = ({
  title,
  open = true,
  onClose,
  children
}: DrawerProps) => {
  const { state } = useDrawer()
  const { size } = state

  return (
    <JoyDrawer
      open={open}
      onClose={onClose}
      anchor="right"
      hideBackdrop={true}
      disableEnforceFocus={true}
      disableScrollLock={true}
      slotProps={{
        content: {
          sx: {
            ...(size === 'large' ? { width: '50%' } : {}),
            margin: '8px',
            height: 'calc(100% - 16px)'
          }
        }
      }}
    >
      <Sheet
        sx={{
          display: 'flex',
          flexDirection: 'column',
          height: '100%',
          overflow: 'auto',
          boxShadow: 'lg',
          border: '1px solid',
          borderRadius: '4px',
          borderColor: 'neutral.300',
          bgcolor: 'background.body'
        }}
      >
        <Box pb="8px" pt="16px" px="12px">
          <DialogTitle sx={{ lineHeight: '32px', fontWeight: 500 }}>
            {title}
          </DialogTitle>
          <ModalClose />
        </Box>
        <Divider />

        {children}
      </Sheet>
    </JoyDrawer>
  )
}

export const Drawer = (props: DrawerProps) => (
  <DrawerProvider>
    <DrawerContent {...props} />
  </DrawerProvider>
)
